import {IsoDate} from "../../../../pseudo-types/DateTypes";

export class DateSelectorEvent {

    private constructor(public readonly date: IsoDate,
                        public readonly isExpiry: boolean,
                        public readonly isTrade: boolean) {

    }

    public static create(date: IsoDate, isExpiry: boolean, isTradeDate: boolean): DateSelectorEvent {
        return new DateSelectorEvent(date, isExpiry, isTradeDate);
    }
}
